import { render } from "./MiNotification.vue?vue&type=template&id=11c913b8"
import script from "./MiNotification.vue?vue&type=script&lang=js"
export * from "./MiNotification.vue?vue&type=script&lang=js"

import "./MiNotification.vue?vue&type=style&index=0&id=11c913b8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__